import * as React from 'react';
import { Create } from 'react-admin';
import { useTranslation } from 'react-i18next';
import { MembersFormContent } from './membersFormContent';

const createContainerSx = {
  '& .MuiTableBody-root tr:last-of-type td': { borderBottom: 'none' },
  // Przy actions={false} react-admin dodaje margin-top: 1em — naglowek (i strzalka
  // "wroc") siedzial przez to 16px nizej niz na pozostalych ekranach.
  '&& .RaCreate-noActions': { marginTop: 0 },
};

export const MembersTableCreate = () => {
  const { t } = useTranslation();
  return (
    <Create title={t('resources.members')} actions={false} component="div" sx={createContainerSx}>
      <MembersFormContent mode="create" />
    </Create>
  );
};
